'use strict';

angular.module('shiftTraderApp')
  .controller('EnterCtrl', ['$state', 'Session', function($state, Session) {
    if (Session.isLoggedIn()) {
      Session.getMe()
        .then(function (me) {
          if (me.$isNotEmployee()) {
            if (me.sign_in_count <= 1) {
              $state.go('organizationProfile.show', {orgId: me.memberships[0].organization.id});
            } else {
              $state.go('manageTrades');
            }
          } else {
            $state.go('workPeriods', {userId: 'me'});
          }
        }, function() {
          $state.go('login', {resetCode: undefined, activationCode: undefined});
        })
    }
  }]);
